var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.switchLocale()}}},[_vm._v(_vm._s(_vm.$root.$i18n.locale.toUpperCase()))])}
var staticRenderFns = []

export { render, staticRenderFns }